
import ReceiptDiscount from "../../../assets/duotone/ReceiptDiscount.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptDiscountIcon({ className, dataTestid = "ReceiptDiscountIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptDiscount data-testid={dataTestid} className={classes} {...rest} />
  );
}
